import React from "react";

import { TabsStyled, TabStyled } from "./styled";

export const Tabs = ({ data, ...rest }) => {
	//reduce tabs array depending if they have visibility property set to false
	let visibleTabs = data.reduce((ids, tab) => {
		if (!tab.hidden) {
			ids.push(tab);
		}
		return ids;
	}, []);

	return (
		<TabsStyled {...rest}>
			{visibleTabs.map(({ link, testId, title }, index) => {
				console.log(`testId ${testId}`);
				return (
					<TabStyled
						to={link}
						key={index}
						testId={testId}
					>
						{title}
					</TabStyled>
				);
			})}
		</TabsStyled>
	);
};
